export default "__VITE_PUBLIC_ASSET__94ee2066__"